import script from "./HijoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HijoCard.vue?vue&type=script&setup=true&lang=js"

import "./HijoCard.vue?vue&type=style&index=0&id=5fe92973&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe92973"]])

export default __exports__